
export class DateRangeQueryParams {
    from: string | null;
    to: string | null;
    period: string | null;

    constructor(props?: {
        from?: string;
        to?: string;
        period?: string;
    }) {
        if (props) {
            Object.assign(this, props);
        }
    }

    get extractPeriodNumber(): number {
        const match = this.period?.match(/(\d+)/);
        return match ? parseInt(match[0], 10) : -1;
    }
}

export class DateRange {
    // coverage	will add from/to values of the data coverage
    from: string;
    to: string;
    iso: string;

    constructor(
        props?: {
            from?: string;
            to?: string;
            iso?: string;
        }) {
        if (props) {
            Object.assign(this, props);
        }
    }

    get fromAsDate(): Date | undefined {
        if (this.from) {
            return new Date(this.from);
        }
        return undefined;
    }

    get toAsDate(): Date | undefined {
        if (this.to) {
            return new Date(this.to);
        }
        return undefined;
    }

    get range(): Array<(Date | undefined)> {
        return [this.fromAsDate, this.toAsDate];
    }

    get kiwisQueryParams(): DateRangeQueryParams {
        return new DateRangeQueryParams({ from: this.from, to: this.to, period: this.iso });
    }
}
